import React from 'react';
import { cn } from '@/lib/cn';

const Input = React.forwardRef(({ 
  className, 
  type, 
  label, 
  error, 
  icon: Icon,
  id,
  ...props 
}, ref) => {
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
            <Icon className="h-5 w-5" />
          </div>
        )}
        <input
          type={type}
          id={id}
          className={cn(
            "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
            Icon && "pl-10",
            error ? "border-red-500 focus-visible:ring-red-500" : "border-gray-200",
            // If className was passed to wrapper, we might not want it here, but usually it's fine or specific input classes are needed.
            // But since we moved className to wrapper, we should check if any classes were meant for input.
            // For now, let's assume className is for positioning/layout (wrapper).
            // But wait, if className has 'w-full', both wrapper and input need it.
            // Let's rely on standard Tailwind 'w-full' being on input by default above.
          )}
          ref={ref}
          {...props}
        />
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
});

Input.displayName = 'Input';

export { Input };
export default Input;
